export default "/images/NCCN.png?2773266a9702944ca232107a9756e872";